import { george, observer, pr, React, RouteComponentProps, theme, ui, debug } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { CreditCardUpgradeRoutes } from "./CreditCardUpgradeRoutes";
import { CreditCardUpgradeStore } from "./CreditCardUpgradeStore";

type IProps = RouteComponentProps<{}> & {
    store: CreditCardUpgradeStore;
};

@observer
export class CreditCardUpgradeSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                useWebVersion
                signingInfo={this.props.store.signInfo}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("common.summary")}
                            </george.SectionTitle>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <george.ResponsiveSummaryElement label={ui.__("signing.action.label")}>
                                <pr.SigningLabel>
                                    {ui.__("creditCardUpgrade.summary.action.description", { productName: this.props.store.upgradeDetails?.offer?.product })}
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                        </div>
                    </>

                }
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute(CreditCardUpgradeRoutes.SUCCESS);
                }}
                onRetry={async () => {
                    await this.props.store.postUpgrade();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradeSigning.tsx